<template>
    <div data-testid="funnel-page" class="css-1y4mw2z">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
}
</script>
